import { httpClient } from "../http-client/base-client";
import { ApiCategories } from "../types/categories/api-types";

export const CategoriesResource = {
  async getCategories(): Promise<ApiCategories> {
    const categories = await httpClient.get<ApiCategories>("categories");
    return categories;
  },
};
